const setupEndpoints = {};

const fileEndpoints = {
  document: '/document/downloadFile',
  saleFile: '/sale/uploadFile',
};

const globalEndpoints = {
  mailer: '/mailer',
  enumeration: '/enumerations',
};

export const endPoints = {
  user: '/user',
  sale: '/sale',
  saleProduct: '/saleProduct',
  role: '/role',
  brands: '/brand',
  model: '/model',
  ccaa: '/ccaa',
  cacl: '/itp/calc',
  cMoto: '/itp/calc/cMoto',
  eMoto: '/itp/calc/Emoto',
  redsys: '/redsys',
  contacts: '/contact',
  ...setupEndpoints,
  ...globalEndpoints,
  ...fileEndpoints,
};
